module.exports = __webpack_public_path__ + "img/jsjj.bcda8b59.jpg";